// extracted by mini-css-extract-plugin
export default {"container":"notification_read_status-module__container--1hdkU"};